/**
 * Плагин для очистки старых комбо из localStorage при загрузке приложения
 */

import consola from 'consola'
import { clearLegacyCombosFromStorage } from '~/utils/cart/migrateCartData';

export default defineNuxtPlugin(() => {
  if (process.client) {
    // Очищаем старые комбо при загрузке приложения
    const clearedCount = clearLegacyCombosFromStorage();

    if (clearedCount > 0) {
      consola.info(`✅ Cleared ${clearedCount} legacy combo(s) from cart`);

      // Можно показать уведомление пользователю
      // useNotification().show({
      //   type: 'warning',
      //   message: `Удалено ${clearedCount} устаревших комбо. Пожалуйста, добавьте их заново.`
      // });
    }
  }
});


